import { Link } from 'react-router-dom';

export const projects = [
        {
            id: 1,
            title: "Deep Bayesian Analysis on Kidney Transplant",
            description:( 
            <>
        An application of DeepSurv model by <a href="https://doi.org/10.1186/s12874-018-0482-1">Katzman et al. (2018)</a> on the kidney transplant data from <a href="https://optn.transplant.hrsa.gov/data/">Organ Procurement & Transplant Network</a>.
      </>),
            url: "https://heyingdu.github.io/#/posts/Deep%20Bayesian%20Analysis%20on%20Kidney%20Transplant/"
        },
        {
            id: 2,
            title: "Double Machine Learning for Censored Data",
            description: (
<>Innovated by <a href="https://doi.org/10.1111/ectj.12097">Chernozhukov et al. (2018)</a>, this method is used to estimate the treatment effect in the presence of censoring.
</>
            ),
            url: "https://heyingdu.github.io/#/posts/Double%20Machine%20Learning%20for%20Censored%20Data/"
        }
        ];
const Research = () => {
    return (

        <main className="flex-grow flex flex-col justify-center items-center p-6 overflow-auto">
            <div className="text-center w-full max-w-5xl mx-auto">
                {/* Projects Display */}
                <div className="text-left w-full mt-8">
                    {projects.map((project) => (
                        <div key={project.id} className="mb-16">
                            <Link to={project.url} className="cursor-pointer hover:opacity-80 transition-opacity inline-block">
                                <h2 className="text-xl md:text-2xl font-bold mb-2 relative group">
                                    {project.title}
                                    <span className="block h-[1px] bg-gradient-to-r from-black to-gray-400 mt-1 w-[125%] group-hover:w-full transition-all duration-500"></span>
                                </h2>
                            </Link>
                            <div className="pl-8 text-left text-gray-700 text-sm md:text-base [&_a]:no-underline [&_a]:text-blue-700 [&_a:hover]:text-blue-700 [&_a:hover]:opacity-80 ">
                                {project.description}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </main>
    );
};

export default Research;